import actualBackend from "./backend";

const url_prefix = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3000/api';

const backend = actualBackend(() => {
    console.log("Redirecting to login");
    window.location = url_prefix + "/oauth";
});

export default backend;